<template>
  <div :class="['-order-select', orderSelectClasses]">
    <div class="-order-select__title">
      {{ $t("MSG_TXT_ORDERSELECT_TITLE") }}
    </div>
    <div
      v-select-click-outside="closeSelectBox"
      :class="['-order-select__input', orderSelectInputClasses]"
      @click="onClickSelectBox"
    >
      <sui-order-select-item v-if="currentItem"
        :option="currentItem"
        :is-simple="isSimple"
      />
    </div>
    <transition name="-order-select__transition">
      <ul
        v-show="isActive"
        class="-order-select__ul"
        :style="orderSelectListStyle"
      >
        <li
          v-for="item in optionList"
          :key="item.key"
          :class="[
            '-order-select__li',
            { '-order-select-item__selected': item.key === currentItem.key },
            { '-order-select-item__disabled': item.disabled },
          ]"
          @click="onClickItem(item)"
        >
          <sui-order-select-item
            :option="item"
            :is-simple="isSimple"
          />
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
// import OrderSelectItem from './OrderSelectItem';

// TODO: impl.
export default {
  name: 'CmpOrderSelect',
  directives: {
    // select가 아닌 외부 영역 click이벤트 발생시, 닫힘처리
    'select-click-outside': {
      bind(el, binding) {
        // Define Handler and cache it on the element
        const handler = e => {
          if (!el.contains(e.target) && el !== e.target) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener('click', handler);
      },

      unbind(el) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      },
    },
  },
  components: {
    // OrderSelectItem,
  },
  props: {
    // 옵션리스트 중 선택된 값
    value: {
      type: Object,
      required: true,
    },

    // 표기 대상인 옵션 리스트
    optionList: {
      type: Array,
      default: () => [],
    },

    // 선택가능 여부
    disabled: {
      type: Boolean,
      default: false,
    },

    // 긴텍스트항목의 경우 말줄임표 처리 여부
    ellipsis: {
      type: Boolean,
      default: false,
    },

    // select 선택항목의 max-height를 지정. px단위의 값만 입력 가능
    listHeight: {
      type: [String, Number],
      default: '',
    },

    // Simple 타입 여부: 날짜 제외, 차수와 status 만 표현되는 타입인지
    isSimple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 옵션 리스트 펼침 여부
      isActive: false,

      // 선택된 값
      currentItem: this.value,
    };
  },
  computed: {
    orderSelectClasses() {
      return [
        { '-order-select__active': this.isActive },
        { '-order-select__ellipsis': this.ellipsis },
        { '-order-select__selected': this.isSelected },
        { '-order-select__disabled': this.disabled },
      ];
    },

    orderSelectInputClasses() {
      return [
        { '-order-select-input__selected': this.isSelected },
        { '-order-select-input__disabled': this.disabled },
      ];
    },

    orderSelectListStyle() {
      const styles = [];
      if (this.listHeight) {
        styles.push({
          'max-height': `${this.listHeight}px`,
        });
      }
      return styles;
    },
  },
  mounted() {
    if (this.optionList.length && !this.currentItem) {
      this.select(this.optionList[0]);
    }
  },
  watch: {
    value() {
      if (this.value) {
        this.select(this.value);
      }     
    },
  },
  methods: {
    /**
     * input영역 클릭 이벤트 발생 시 선택가능 여부에 따라 옵션 리스트 펼침 처리
     */
    onClickSelectBox() {
      this.setIsActive(!this.isActive);
    },

    /**
     * 외부 영역 클릭 이벤트 발생 시 자동닫힘 처리
     */
    closeSelectBox() {
      this.setIsActive(false);
    },

    /**
     * 옵션 리스트 클릭 이벤트 발생 시 선택된 옵션을 현재 선택값에 반영
     */
    onClickItem(item, preventClickEvent) {
      if (this.currentItem === item) {
        return;
      }
      this.currentItem = item;
      this.$emit('input', item);
      this.setIsActive(false);
      if (preventClickEvent === true) {
        return;
      }
      this.$emit('list-click', item);
    },
    setIsActive(isActive) {
      this.isActive = isActive;
    },
    select(key) {
      let item = null;
      if (key === null) {
        this.clear();
      } else if (key.constructor.name === 'String') {
        item = _.find(this.optionList, option => { return option.key === key });
      } else if (key.constructor.name === 'Object') {
        item = _.find(this.optionList, option => { return key === option })
      }
      if (item) {
        this.onClickItem(item, true);
      }
    },
    setInitSetting(key) {
      this.select(key);
      // const InitItem = utils.find(this.optionList, e => e.key === key);
      // this.currentItem = InitItem;
      // if (this.optionList.length > 0 && this.currentItem) {
      //   this.$emit('select', this.currentItem);
      // }
    },
    clear() {
      const item = { key: '', label: '' };
      this.currentItem = item;
      this.$emit('input', item);
    },    
  },
};
</script>

<style scoped>
</style>
